<template>
  <div class="container">
    <el-card>
      <el-row>
        <el-col>
          <el-form :inline="true" label-width='80px'>
            <el-form-item label="时间">
              <el-date-picker size="small"
                v-model="appForm.daterange"
                type="daterange"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                @change="changeDate()"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="App">
              <el-select v-model="appForm.app" placeholder="请选择APP" size="small" @change="changeApp"
                style="width:220px;" filterable>
                <el-option v-for="app of apps" :key="app.realname" :value="app.realname">
                  <span style="float: left">{{ app.realname }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ app.src }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="国家">
              <el-select placeholder="请选择国家" v-model="appForm.country" size="small"
                clearable filterable multiple default-first-option>
                <el-option
                  v-for="country in countryConfig"
                  :key="country.country_code2"
                  :value="country.country_code2">
                  <span style="float: left">{{ country.country_code2 }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ country.name_zh }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="版本">
              <el-select placeholder="请输入版本" v-model="appForm.appVersion" size="small"
                clearable filterable multiple allow-create default-first-option>
                <el-option v-for="ver of versions" :key="ver" :value="ver">
                  {{ ver }}
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
    <el-row style="margin-top: 20px;">
      <el-col :span="18" class="content-box">
        <el-card style="height: 750px; margin-right: 10px">
					<el-row>
            <el-col>
              <el-radio-group v-model="chartType" size="mini" @change="changeChartType"
                style="display: inline-block; float:right; margin: 50px">
                <el-radio-button label="pv">PV</el-radio-button>
                <el-radio-button label="uv">UV</el-radio-button>
              </el-radio-group>
            </el-col>
					</el-row>
          <div style="height: 500px; text-align: center" v-if="!chartView">
            <img src="@/assets/imgs/funnel.svg">
          </div>
          <div ref='funnelChart' style="height:500px"></div>
        </el-card>
      </el-col>
      <el-col :span="6" class="content-box">
        <el-card style="height: 750px">
          <div style="padding: 5px">
            <el-button size="small" type="primary" @click="addItem">Add Item</el-button>
            <el-button size="small" type="success" @click="search" style="float: right" icon="el-icon-search"
              v-if="appForm.app && (appForm.daterange||[]).length == 2 && appForm.events.length>1">Query</el-button>
          </div>
          <el-divider></el-divider>
          <div style="max-height: 600px; overflow: auto">
            <div v-for="(event, idx) in appForm.events" class="event-card" :style="event.style" @click="editEventParam(event)">
              <div style="padding: 5px 0"><span style="font-weight: bold; font-size: 16px">{{ event.name }}</span></div>
              <div>
                <span v-for="p in event.params" class="param-span" v-if="p.key">
                  {{ p.key }}: {{ p.value }} <el-divider direction="vertical"></el-divider></span>
              </div>
              <div>
                <span v-if="event.test_id" class="param-span" >test_id: {{ event.test_id }}</span>
                <span v-if="event.option_ids.length>0" class="param-span" >option_ids: [{{ event.option_ids.join(',') }}]</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%">
      <el-form label-width="150px" :ref="eventForm" :model="eventForm">
        <el-form-item label="事件名">
          <el-select v-model="eventForm.name" placeholder="请选择事件名称" @change="changeEvent"
            filterable allow-create default-first-option>
            <el-option v-for="ev of events" :key="ev" :value="ev">
              {{ ev }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事件参数">
          <el-row v-for="(p, idx) in eventForm.params" :key="idx" style="margin-bottom: 10px">
            <el-col :span="10">
              <el-select v-model="p.key" placeholder="请选择事件参数" @change="changeEventProperty(idx)"
                filterable clearable allow-create default-first-option>
                <el-option v-for="prop of properties" :key="prop" :value="prop">
                  {{ prop }}
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-select v-model="p.value" placeholder="请选择参数值"
                filterable allow-create default-first-option :popper-append-to-body="false">
                <el-option v-for="v of p.propertyValues" :key="v" :value="v">
                  {{ v }}
                </el-option>
              </el-select>
            </el-col>
            <el-col :span='2' class='align-center'>
              <i class='el-icon-plus add-icon' @click='addEventParam'
                v-if='idx==eventForm.params.length - 1'></i>
              <i class='el-icon-delete delete-icon' @click='deleteEventParam(idx)'
                v-if='idx>0'></i>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="实验分组">
          <el-row>
            <el-col :span="10">
              <el-select placeholder="请选择组别" v-model="eventForm.test_id" size="small" filterable clearable>
                <el-option v-for="item of abTestOptions" :key="item.id" :value="item.id">
                  {{ item.id }}: {{ item.name }}
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-select placeholder="请选择权重参数" v-model="eventForm.option_ids" size="small" multiple clearable>
                <el-option v-for="item of abTestChildrenOptions" :key="item.id" :value="item.id">
                  {{ item.id }}: {{ item.weight }}
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="eventForm.id" @click="deleteItem(eventForm.id)" type="danger"
          style='float: left'>删 除</el-button>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import * as echarts from 'echarts';
require('echarts/theme/macarons')
const emptyEvent = {
  id: 0,
  name: '',
  params: [
    {key: '', value: ''}
  ],
  test_id: '',
  option_ids: [],
}
const colors = [
  '84,112,198', '145,204,117', '250,200,88', '238,102,102', '115,192,222',
  '59,162,114', '252,132,82', '154,96,180', '234,124,204'
];
const sqlTools = require('@/assets/js/sqls');

export default {
  data() {
    return {
      apps: [
      ],
      versions: [],
      events: [],
      properties: [],
      propertyValues: [],
      countryConfig: require('@/assets/config/country'),
      daterange: [],
      appForm: {
        system: this.$route.params.system,
        app: undefined,
        daterange: [],
        appVersion: [],
        country: [],
        events: [
        ],
      },
      eventForm: {
        name: '',
        params: [
          {key: '', value: ''}
        ],
        test_id: '',
        option_ids: [],
      },
      abTestOptions: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 86400000 || time.getTime() < 1651334400000;
        }
      },
      dialogTitle: '',
      dialogVisible: false,
      cache: {},
      chart: undefined,
      chartType: 'pv',
      chartView: false,
    }
  },
  mounted() {
    let m = moment();
    let y = m.subtract(1, 'days').format('YYYY-MM-DD');
    this.appForm.daterange = [y, y];
    this.getApps();
    this.getAbTestOptions();
  },
  computed: {
    abTestChildrenOptions() {
      if (this.eventForm.test_id) {
        return this.abTestOptions.find(o => o.id == this.eventForm.test_id).options;
      }
      return [];
    }
  },
  methods: {
    getAbTestOptions() {
      let url = `/etp/v1.0/event/abtest/list`;
      this.$http.get(url).then(rst => {
        this.abTestOptions = rst.data.data;
      });

    },
    addItem() {
      this.dialogTitle = 'Add Item';
      this.eventForm = JSON.parse(JSON.stringify(emptyEvent));
      this.dialogVisible = true;
    },
    deleteItem(id) {
      this.$confirm(`确认删除?`).then(() => {
        this.appForm.events = this.appForm.events.filter((e) => e.id != id);
        this.dialogVisible = false;
      })
    },
    changeDate() {
    },
    addEventParam() {
      this.eventForm.params.push({ key: '', value: '' });
    },
    editEventParam(event) {
      this.dialogTitle = 'Edit Item';
      if (event.params.length == 0) {
        event.params.push({key: '', value: ''})
      }
      this.eventForm = event;
      this.dialogVisible = true;
    },
    deleteEventParam(idx) {
      this.eventForm.params.splice(idx, 1);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    submit() {

      if (!this.eventForm.name) {
        this.$notify({
          title: '警告',
          message: '请输入事件名称',
          type: 'warning'
        });
        return
      }

      let ev = JSON.parse(JSON.stringify(this.eventForm))
      let id = ev.id;

      if (id == 0) {
        id = this.appForm.events.length == 0 ? 1: this.appForm.events[this.appForm.events.length - 1].id + 1
      }

      ev.id = id;
      if (!ev.style) {
        let rgb = id <= colors.length ? colors[id-1]: this.randomRGB();
        ev.style = { borderColor: `rgb(${rgb})`, backgroundColor: `rgba(${rgb}, 0.2)` };
      }

      this.appForm.events[id - 1] = ev;
      this.dialogVisible = false;

    },
    async getEventParams(key) {
      let url = `/etp/v1.0/event/params/list?key=${key}&system=${this.$route.params.system}`;
      let rst = await this.$http.get(url)

      return rst.data.data.map(p => p.value);

    },
    async getApps() {
      let apps = await this.getEventParams('app')
      this.apps = apps.map(app => { 
        let [n, s] = app.split(':');
        let src = '未知来源';
        switch (s) {
          case undefined:
            src = this.$route.params.system == 'mod' ? 'Flurry' : 'ETP';
            break
          case 'server':
            src = '服务端';
            break
          case 'flurry':
            src = 'Flurry';
            break
          case 'firebase':
            src = 'Firebase';
            break
        }

        return { name: n, src: src, realname: app };
      })
    },
    changeApp(app) {
      this.getAppVersions(app);
      this.getAppEvents(app);
    },
    async getAppVersions(app) {
      let versions = await this.getEventParams(`${app}::app::version`);
      this.versions = versions;
    },
    async getAppEvents(app) {
      let events = await this.getEventParams(app);
      this.events = events;
    },
    changeEvent(ev) {
      this.properties = [];
      this.propertyValues = [];
      this.getEventProperties(ev);
    },
    async getEventProperties(ev) {
      let props = await this.getEventParams(`${this.appForm.app}::${ev}`);
      this.properties = props;
    },
    changeEventProperty(idx) {
      this.getEventPropertyValues(idx);
    },
    async getEventPropertyValues(idx) {
      let params = JSON.parse(JSON.stringify(this.eventForm.params));
      let pv = await this.getEventParams(`${this.appForm.app}::${this.eventForm.name}::${params[idx].key}`);
      params[idx].propertyValues = pv;
      this.eventForm.params = params;
    },
    randomRGB() {
        return parseInt((Math.random()+0.8)*100)+','+parseInt((Math.random()+0.8)*100)+','+parseInt((Math.random()+0.8)*100)
    },
    async search() {

			this.setChartLoading();

      let form = JSON.parse(JSON.stringify(this.appForm));

      let pros = form.events.map((event)=>{
        let url = "/etp/v1.0/event/stat/abtest";
        let params = {
          start_date: form.daterange[0],
          end_date: form.daterange[1],
          app: form.app,
          countries: form.country,
          app_versions: form.appVersion,
          event: event.name,
          event_params: event.params,
        }
        if(event.test_id){
          params.ab_test_id = event.test_id;
          if(event.option_ids.length>0){
            params.options = event.option_ids
          }
        }
        let p = this.$http.post(url, params);
        return p;
      })

      let rst = await Promise.all(pros);

      this.cache.appForm = form;
      this.cache.result = rst.map((r) => r.data.data||[]);
			
      this.changeChartType();

    },
    changeChartType() {
      this.chartView = true;
      this.setChart(this.chartType);
    },
    setChartLoading() {

      this.chartView = true;

      if (!this.chart) {
        this.chart = echarts.init(this.$refs.funnelChart);
      }

			let option = {
			  // graphic: {
			  //   elements: [
			  //     {
			  //       type: 'group', left: 'center', top: 'center',
			  //       children: new Array(7).fill(0).map((val, i) => ({
			  //         type: 'rect', x: i * 20,
			  //         shape: { x: 0, y: -40, width: 10, height: 80 },
			  //         style: { fill: '#5470c6' },
			  //         keyframeAnimation: {
			  //           duration: 1000,
			  //           delay: i * 200,
			  //           loop: true,
			  //           keyframes: [
			  //             { percent: 0.5, scaleY: 0.3, easing: 'cubicIn' },
			  //             { percent: 1, scaleY: 1, easing: 'cubicOut' }
			  //           ]
			  //         }
			  //       }))
			  //     }
			  //   ]
			  // }
			};

      this.chart.setOption(option, true);

    },
    setChart(dataType) {

      if (!this.chart) {
        this.chart = echarts.init(this.$refs.funnelChart);
      }

      let data = [];
      if (!this.cache.result) {
        return;
      }

      let events = this.cache.appForm.events;
      let result = this.cache.result;

      for (let i=0; i<events.length; i++) {
        const currentResult = result[i];
        const currentEvent = events[i];
        const groupData = [];
        for (let j=0; j<currentResult.length; j++) {
          const currentOptionResult = currentResult[j];
          const test_id = currentOptionResult.ab_test_id;
          const option_id = currentOptionResult.option_id;

          let name = currentEvent.name;
          let pv = currentOptionResult.pv;
          let uv = currentOptionResult.uv;

          let color = currentEvent.style.borderColor;

          let params = currentEvent.params.filter((x) => x.key)
          params = params.map((p) => `${p['key']}:${p['value']}`).join(", ");
          if(test_id){
            params += ` ${test_id}:${option_id}`;
          }

          groupData.push({ name, pv, uv, color, params })
          
        }
        groupData.sort((a, b) => b.pv - a.pv);

        data = data.concat(groupData);

      }

      let option = {
        title: {
          left: 'center',
          text: `漏斗分析-${dataType.toUpperCase()}`
        },
        legend: {
        },
        xAxis: {
          type: 'category',
          data: data.map(d => `${d.name}(${d.params})`)
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove'
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            saveAsImage: { show: true }
          }
        },
        series: [
          {
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: data.map(d => { return { value: d[dataType], itemStyle: { color: d.color }}}),
            type: 'bar',
            barWidth: '30%'
          }
        ]
      };

      // let chart = echarts.init(this.$refs.funnelChart);
      this.chart.setOption(option, true);

    }
  }
}
</script>
<style lang="less" scoped>

.container {
  padding: 20px;
}
.content-box {
  min-height: 800px;
}

.event-card {
  min-height: 60px;
  cursor: pointer;
  margin: 8px 5px;
  padding: 5px;
  border-left: 4px solid;
  border-radius: 3px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.param-span {
  display: inline-block;
  padding-right: 10px;
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  max-width:100%;
}

.align-center {
  text-align: center;
}

::v-deep(.el-select-dropdown) {
  max-width: 100%;
}

</style>
